// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
    LoadRecentlyViewed,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";

export const XngLoadScratchAndDent: typeof LoadRecentlyViewed = props => {
    const {
        parameter: { carouselType, isProductDetailsPage, productId, numberOfProductsToDisplay },
    } = props;
    if (carouselType !== "scratch & dent" || (isProductDetailsPage && !productId)) {
        return;
    }
    // make sure we reset the pending loading if any

    props.getProductCollectionParameter = {
        productId,
        pageSize: numberOfProductsToDisplay,
        relationship: carouselType,
    };
};

export const XngLoadProducts: typeof LoadProducts = async ({
    dispatch,
    getProductCollectionParameter,
    extraProductCollectionParameter,
    additionalSort,
    parameter: { carouselId, carouselType, numberOfProductsToDisplay, isProductDetailsPage, productId, isShellEdit },
    getState,
}) => {
    if (!getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = extraProductCollectionParameter
        ? {
              getProductCollectionParameter: extraProductCollectionParameter,
              numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP = carouselType === "recentlyViewed" && isProductDetailsPage;

    getProductCollectionParameter.expand
        ? getProductCollectionParameter.expand.push("images", "badges")
        : (getProductCollectionParameter.expand = ["images", "badges"]);

    // <XNG-Change>: Make sure is Loading is false, when we have return from pdp while its loading.
    let forceLoad = isRecentlyViewedOnPDP;
    if (isProductDetailsPage) {
        const productsDataViewState = getProductsDataView(getState(), getProductCollectionParameter);
        if (productsDataViewState.isLoading) {
            dispatch({
                type: "Data/Products/CompleteLoadProducts",
                collection: { products: [] } as any,
                parameter: getProductCollectionParameter,
            });
            forceLoad = true;
            await new Promise(resolve => setTimeout(() => resolve(true), 100));
        }
    }
    // </XNG-Change>

    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? productId : undefined,
            // <XNG-Change>
            forceLoad,
            // </XNG-Change>
            isShellEdit,
            additionalSort,
        }),
    );
};

addToChainAfter(chain, LoadRecentlyViewed, XngLoadScratchAndDent);
replaceInChain(chain, LoadProducts, XngLoadProducts);
